const storeId = {
	store: {
		title: "Toko",
		subtitle: "Ringkasan daftar toko",
		table_title: "Data Toko",
		empty_title: "Tidak ada data toko",
		empty_description: "Silakan tambahkan toko baru.",
		detail: {
			back: "Kembali",
			info_title: "Informasi Toko",
			not_found: "Toko tidak ditemukan.",
			tabs: {
				qr: "QR Pembayaran",
				hours: "Jam Operasional",
			},
		},
		qr: {
			title: "QR Pembayaran",
			add: "Tambah QR",
			code: "Kode",
			code_placeholder: "Kosongkan agar dibuat otomatis",
			created_at: "Dibuat Pada",
			download: "Unduh QR",
			empty_state: {
				title: "Belum ada QR pembayaran",
				description:
					"Tambahkan QR agar pelanggan dapat membayar dengan memindai.",
			},
			add_success: "QR pembayaran berhasil dibuat",
		},
		hours: {
			title: "Jam Operasional",
			enable: "Aktifkan jam operasional",
			different_daily: "Jam berbeda tiap hari",
			open: "Buka",
			close: "Tutup",
			holiday: "Libur",
			save: "Simpan",
			success: "Jam operasional berhasil disimpan",
			timezone_note:
				"Jam disimpan dalam UTC dan ditampilkan mengikuti zona waktu perangkat Anda.",
			days: {
				monday: "Senin",
				tuesday: "Selasa",
				wednesday: "Rabu",
				thursday: "Kamis",
				friday: "Jumat",
				saturday: "Sabtu",
				sunday: "Minggu",
			},
		},
		columns: {
			created_at: "Dibuat Pada",
			name: "Nama Toko",
			category: "Kategori",
			address: "Alamat",
			phone: "No. Telepon",
			pic: "PIC",
			pic_phone: "No. Telepon PIC",
			status: "Status",
		},
		status: {
			active: "Aktif",
			inactive: "Non Aktif",
		},
		add: {
			button: "Tambah Toko",
			title: "Tambah Toko",
			description: "Tambah data toko baru",
			success: "Berhasil!",
			success_description: "{name} berhasil ditambahkan!",
			error: "Terjadi kesalahan!",
			error_description: "Coba lagi beberapa saat!",
		},
		edit: {
			title: "Edit Toko",
			section_info: "Informasi Toko",
			section_pic: "Informasi PIC",
			section_settings: "Pengaturan Toko",
			section_rounding: "Pengaturan Pembulatan",
			section_footer_printer: "Footer Printer",
			saving: "Menyimpan...",
			save: "Simpan Perubahan",
		},
		delete: {
			title: "Hapus Toko",
			confirm: "Apakah anda yakin ingin menghapus {name}?",
			button: "Hapus",
		},
		form: {
			name: "Nama Toko",
			phone: "Nomor Telepon",
			address: "Alamat",
			pic_name: "Nama PIC",
			pic_phone: "Nomor Telepon PIC",
			category: "Kategori",
			category_placeholder: "Pilih Kategori",
			category_loading: "Memuat...",
			category_empty: "Belum ada data kategori toko",
			is_retail: "Toko Retail",
			is_retail_question: "Toko retail?",
			enable_ppob: "Enable PPOB",
			enable_ppob_question: "Enable PPOB?",
			enable_daily_limit: "Enable Daily Limit",
			enable_daily_limit_question: "Enable Daily Limit?",
			enable_card_redeem: "Enable Card Redeem",
			enable_card_redeem_question: "Enable Card Redeem?",
			round_type: "Round Type",
			round_type_placeholder: "Pilih Round Type",
			round_order: "Round Order",
			footer_printer: "Footer Printer",
			footer_printer_placeholder: "Footer Printer {index}",
			add_footer: "Add Footer Printer",
			remove: "Remove",
		},
		actions: {
			cancel: "Batal",
			save: "Simpan",
		},
	},
};

export default storeId;
